
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referral-program",
      function () {
        return require("private-next-pages/referral-program/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referral-program"])
      });
    }
  